const apiUrl = import.meta.env.VITE_API_URL as string

async function publicRequest<T>(method: string, path: string, body?: unknown): Promise<T> {
  const res = await fetch(`${apiUrl}${path}`, {
    method,
    headers: { 'Content-Type': 'application/json' },
    body: body !== undefined ? JSON.stringify(body) : undefined,
  })

  if (!res.ok) {
    const json = await res.json().catch(() => ({}))
    throw new Error((json as { error?: { message?: string } }).error?.message ?? `HTTP ${res.status}`)
  }

  return res.json() as Promise<T>
}

export function publicGet<T>(path: string): Promise<T> {
  return publicRequest<T>('GET', path)
}

export function publicPost<T>(path: string, body: unknown): Promise<T> {
  return publicRequest<T>('POST', path, body)
}

export async function apiGet<T>(path: string, token: string): Promise<T> {
  const res = await fetch(`${apiUrl}${path}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  })

  if (res.status === 401) {
    throw new Error('UNAUTHORIZED')
  }

  if (!res.ok) {
    const body = await res.json().catch(() => ({}))
    throw new Error((body as { error?: { message?: string } }).error?.message ?? `HTTP ${res.status}`)
  }

  return res.json() as Promise<T>
}
